import { removeHighlightColor, setHighlightColor } from 'common/Prose/Commands/formatting/highlightColor'
import { HIGHLIGHT_COLOR_OPTIONS, NO_HIGHLIGHT_COLOR } from 'common/Prose/constants/colorOptions'
import { EditorView } from 'prosemirror-view'
import React from 'react'
import { EditorColorPicker } from '../EditorColorPicker/EditorColorPicker'

export type HighlightColorPickerProps = {
  view: EditorView
  activeColors: string[]
  callback?: () => void
}

export const HighlightColorPicker: React.FC<React.PropsWithChildren<HighlightColorPickerProps>> = (props) => {
  const { view, activeColors, callback } = props
  return (
    <EditorColorPicker
      aria-label={(color: string) => `Change highlight color to ${color}`}
      includeDropdownStyles={false}
      colorOptions={HIGHLIGHT_COLOR_OPTIONS}
      defaultColor={NO_HIGHLIGHT_COLOR}
      activeColors={activeColors}
      noColorButtonPos="bottom"
      noColorButtonLabel="Remove"
      setColor={(color) => {
        // the timeout is necessary for certain browsers (safari) not to eat the selection
        setTimeout(() => setHighlightColor(color, view))
        callback?.()
      }}
      removeColor={() => {
        setTimeout(() => removeHighlightColor(view))
        callback?.()
      }}
    />
  )
}
